module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getStyle),
    attrs: {
      "id": "ruler"
    }
  }, _vm._l((_vm.$store.state.timeScaleTicks), function(ticks, index) {
    return _c('div', {
      staticClass: "rulerTicksCell",
      class: _vm.getTicksClass(index),
      style: (_vm.ticksCellStyle)
    }, [_c('span', {
      staticClass: "rulerTicks"
    }, [_vm._v(_vm._s(ticks))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3854584e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/Ruler.vue
// module id = 687
// module chunks = 0